'use strict';

module.exports = text;

function text(h, node) {
  return h.augment(node, {type: 'text', value: node.value});
}



//////////////////
// WEBPACK FOOTER
// ../node_modules/hast-util-to-mdast/handlers/text.js
// module id = 1016
// module chunks = 0